import { LocaleStrings } from '../Locale'
import { TranslationItem, TranslationsList } from './TranslationTypes'

/** @deprecated Use "Dictionary" instead */
export class Translations {
    private list: TranslationsList = {}

    private constructor(content?: TranslationItem[]) {
        if (!content || content.length === 0) return
        this.list = this.convertFlatData(content)
    }

    /** initialize single set of translations */
    public static init(set: TranslationItem[]): Translations {
        return new Translations(set)
    }

    /**
     * initializes translations in multiple locales
     * @param sets a record of a LocaleString and a translationItem[]
     * @returns translations as {en: <Translations>, nl: <Translations>}
     */
    public static initMultiple(sets: Record<LocaleStrings, TranslationItem[]>): Record<LocaleStrings, Translations> {
        return {
            [LocaleStrings.NL]: Translations.init(sets[LocaleStrings.NL]),
            [LocaleStrings.EN]: Translations.init(sets[LocaleStrings.EN]),
        }
    }

    /** @returns a single translation or the key itself if the translation is not available */
    public instant = (key: string): string => this.list?.[key] || key

    /** @returns a single translation or null if the translation is not available */
    public instantOrNull = (key: string): string | null => this.list?.[key] || null

    /** get a set of translations */
    public filter(mainKey: string): TranslationsList {
        const filtered: TranslationsList = {}
        const cutoff: number = mainKey.endsWith('.') ? mainKey.length : mainKey.length + 1
        Object.entries(this.list).forEach(([key, value]) => {
            if (key.startsWith(mainKey)) filtered[key.slice(cutoff)] = value
        })
        return filtered
    }

    /** replaces params in a translation key */
    public replace(key: string, params: { [key: string]: string | number }): string {
        let translation: string = this.instant(key)
        Object.entries(params).forEach(
            ([param, value]) => (translation = translation.replace(`{{ ${param} }}`, value?.toString() ?? ''))
        )

        return translation
    }

    private convertFlatData(input: TranslationItem[]): TranslationsList {
        const translations: TranslationsList = {}
        input.forEach((item) => {
            if (item?.key) translations[item.key] = item.value || item.key
        })
        return translations
    }
    /** get all translations */
    public get all(): TranslationsList {
        return this.list
    }
}
